<template>
  <form-group
    class="combobox"
    :label="label"
    :errors="errors"
    @focus="focus"
  >
    <multiselect
      ref="primaryInput"
      :placeholder="placeholder"
      :searchable="true"
      :value="internalValue"
      :options="optionsWithDefault"
      :allow-empty="allowEmpty"
      :clear-on-select="true"
      :close-on-select="true"
      :label="labelKey"
      :internal-search="internalSearch"
      :hide-selected="false"
      :track-by="idKey"
      :multiple="multiple"
      :disabled="disabled"
      :loading="isLoading"
      :select-label="$t('hints.select')"
      :deselect-label="$t('hints.deselect')"
      :selected-label="$t('hints.selected')"
      @search-change="onSearchChange"
      @input="onInput"
      @open="$emit('open')"
      @close="$emit('close')"
    >
      <span slot="noResult">
        {{$t('hints.noResults')}}
      </span>
      <span
        v-if="!searchTerm && options.length === 0"
        slot="beforeList"
        class="multiselect__no-options"
      >
        {{$t('hints.noOptions')}}
      </span>

      <template slot="option" scope="props">
        <slot name="option" :option="props.option">
          {{props.option[labelKey]}}
        </slot>
      </template>

      <template slot="singleLabel">
        <slot name="singleLabel" :option="internalValue">
          <template v-if="internalValue">
            {{ internalValue[labelKey] }}
          </template>
        </slot>
      </template>
    </multiselect>
  </form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';
import FormGroup from '@/components/FormGroup';
import Input from '@/mixins/Input';

export default {
  name: 'combobox',
  mixins: [Input],
  components: {
    FormGroup,
    Multiselect,
  },
  data() {
    const data = { searchTerm: null };
    if (this.multiple) {
      data.internalValue = this.value || [];
    } else {
      data.internalValue = this.value;
    }
    return data;
  },
  props: {
    value: null,
    options: Array,
    multiple: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('placeholder.select');
      },
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    idKey: {
      type: String,
      default: 'id',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    internalSearch: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(value) {
      if (this.multiple) {
        this.internalValue = value || [];
      } else {
        this.internalValue = value;
      }
    },
  },
  computed: {
    optionsWithDefault() {
      return this.options || [];
    },
  },
  methods: {
    onSearchChange(searchTerm) {
      this.searchTerm = searchTerm;
      this.$emit('search', searchTerm);
    },
    onInput(selections) {
      this.internalValue = selections;
      this.clearErrors();
      this.$emit('input', selections);
      this.$emit('change', selections);
    },
    focus() {
      this.$refs.primaryInput.activate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Combobox.vue?3b885413